<section class="qb-node" [class.qb-node--root]="isRoot">
  <header class="qb-node__head">
    <div
      class="qb__seg qb__seg--sm"
      *ngIf="canSetOperator; else plainOp"
      role="group"
      aria-label="How this group combines"
    >
      <button
        type="button"
        [class.is-on]="node.operator === 'or'"
        [attr.aria-pressed]="node.operator === 'or'"
        title="One of these is enough"
        (click)="setOperator('or')"
      >
        any one
      </button>
      <button
        type="button"
        [class.is-on]="node.operator === 'and'"
        [attr.aria-pressed]="node.operator === 'and'"
        title="Every one of these has to appear"
        (click)="setOperator('and')"
      >
        all
      </button>
    </div>
    <ng-template #plainOp>
      <span class="qb-node__op">{{ operatorLabel }}</span>
    </ng-template>

    <span class="qb-node__count">{{ countLabel }}</span>

    <span class="qb-node__ctrls" *ngIf="editing">
      <button
        type="button"
        class="qb-node__nest"
        (click)="addGroup()"
        title="Nest a group inside this one"
      >
        + group
      </button>
      <button
        type="button"
        class="qb-group__x"
        *ngIf="!isRoot"
        (click)="remove()"
        title="Remove this group and everything in it"
      >
        ✕
      </button>
    </span>
  </header>

  <!-- The terms and the two ways to add to them share a row: a node is often
       just a container, and three stacked lines per node buried the shape. -->
  <div class="qb-node__terms">
    <ng-container *ngTemplateOutlet="pills; context: termsCtx"></ng-container>
    <ng-container
      *ngIf="editing"
      [ngTemplateOutlet]="pills"
      [ngTemplateOutletContext]="excludedCtx"
    ></ng-container>
  </div>

  <app-query-node
    *ngFor="let child of node.children; trackBy: trackByPath"
    [node]="child"
    [editing]="editing"
    [pills]="pills"
    (nodeAction)="nodeAction.emit($event)"
  ></app-query-node>
</section>
